import React from "react";
import SectionTitle from "../../components/section-title";

const projects = [
  {
    id: "project1",
    number: "01",
    title: "Western Canada Security",
    description:
      "It is Security Company website. It provides security services to the clients in Canada.",
    skills: [
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/gatsby/gatsby-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
    ],
    githubLink: "#",
    liveLink: "https://www.securitywc.com/",
    backgroundImage: `${process.env.PUBLIC_URL}/./images/project/Project1.png`,
    align: "right",
  },
  {
    id: "project2",
    number: "02",
    title: "Sunlight Creationz",
    description:
      "It is a luxury wedding decor and event planning company based in Toronto, Canada.",
    skills: [
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vercel/vercel-original.svg",
    ],
    githubLink: "#",
    liveLink: "https://sunlight-creationz.vercel.app/",
    backgroundImage: `${process.env.PUBLIC_URL}/./images/project/Project3.png`,
    align: "left",
  },
  {
    id: "project3",
    number: "03",
    title: "F5 Alum",
    description:
      "It is a Company that works in the field of railing , awning and all the other aluminum custom jobs",
    skills: [
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vercel/vercel-original.svg",
    ],
    githubLink: "#",
    liveLink: "https://www.f5alum.ca/",
    backgroundImage: `${process.env.PUBLIC_URL}/./images/project/Project2.png`,
    align: "right",
  },
  {
    id: "project4",
    number: "04",
    title: "Sohana Land Promoters",
    description:
      "It is a Real Estate Company that provides land and plots to the clients.",
    skills: [
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vercel/vercel-original.svg",
    ],
    githubLink: "#",
    liveLink: "https://sohana-land-promoters.vercel.app/#/",
    backgroundImage: `${process.env.PUBLIC_URL}/./images/project/Project4.png`,
    align: "left",
  },
  // Add more projects here
];

const Projects = () => {
  return (
    <section className="project-section" id="projects">
      <SectionTitle classOption="text-center" title="Projects" />
      {/* <h2 className="page-header">Projects</h2> */}
      <div className="project-container">
        {projects.map((project) => (
          <a
            href={project.liveLink}
            target="_blank"
            rel="noopener noreferrer"
            className="github"
            key={project.id}
          >
            <div
              className="project-card"
              id={project.id}
              style={{ backgroundImage: `url(${project.backgroundImage})` }}
            >
              <div
                className={`project-number ${
                  project.align === "left"
                    ? "project-number-left"
                    : "project-number-right"
                } `}
              >
                {project.number}
              </div>
              <div
                className={`project-content ${
                  project.align === "left"
                    ? "project-content-right"
                    : "project-content-left"
                }`}
              >
                <div className="project-skills-container">
                  {project.skills.map((url, index) => (
                    <img
                      key={index}
                      className="project-skill"
                      src={url}
                      alt={`Skill-${index}`}
                    />
                  ))}
                </div>
                <h2 className="project-heading">{project.title}</h2>
                <p className="project-subHeading">{project.description}</p>
                <div className="btn-grp">
                  {/* <i title="Live Link" className="fa-solid fa-link icon"></i> */}
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Projects;
